<template>
    <div>
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/withdraw/withdraw' }">财务管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/withdraw/setdk' }">财务设置</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>财务设置</h2>
                <div class="item" @click="toBack"><i class="icon el-icon-caret-left" type="primary"></i>财务管理</div>
            </div>
        </div>
        <div class="page-content p20">
            <div class="form-box p20 bg_fff">
                <div class="item d_flex a_c">
                    <div class="name" style="width: 200px;text-align: left">提现自动打款金额:</div>
                    <div class="val" style="width: 50px;text-align: center;border-bottom: 1px solid #aaa;margin-right: 20px;">{{money}}</div>
                    <el-button class="btn" type="primary" size="mini" @click="updateDk">修改</el-button>
                </div>

                <div class="item d_flex a_c" style="margin-top: 30px;">
                    <div class="name" style="width: 200px;text-align: left">用户查看服务商信息价格:</div>
                    <div class="val" style="width: 50px;text-align: center;border-bottom: 1px solid #aaa;margin-right: 20px;">{{sale_money}}</div>
                    <el-button class="btn" type="primary" size="mini" @click="updateSer">修改</el-button>
                </div>

            </div>

        </div>
        <el-dialog
                title="自动打款金额设置"
                :visible.sync="dkPop"
                width="500px"
        >
            <div class="box">
                <el-form ref="form" label-width="80px">
                    <el-form-item label="金额">
                        <el-input v-model="update_money" type="number" placeholder="请输入整数金额"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dkPop = false">取 消</el-button>
                <el-button type="primary" @click="submitDk">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
                title="用户查看服务商资料价格设置"
                :visible.sync="serPop"
                width="500px"
        >
            <div class="box">
                <el-form ref="form" label-width="80px">
                    <el-form-item label="金额">
                        <el-input v-model="update_sale_money" type="number" placeholder="请输入整数金额"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="serPop = false">取 消</el-button>
                <el-button type="primary" @click="submitSer">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {getdkmoney,setdkmoney,getsermoney,setsermoney} from '../../api/withdraw'
    export default {
        name: "setdk",
        data(){
            return{
                money:0,//自动打款金额
                sale_money:0,//服务商价格设置
                update_money:0,//修改的打款价格
                update_sale_money:0,//修改的服务商价格
                dkPop:false,
                serPop:false,
            }
        },
        created(){
            this.getDkMoney();
            this.getSaleMoney();
        },
        methods:{
            toBack(){
                this.$router.push({path:'/withdraw/withdraw'})
            },
            getSaleMoney(){
                getsermoney().then(res=>{
                    if(res.code==1){
                        this.sale_money=res.data.value;
                    }
                })
            },
            getDkMoney(){
                getdkmoney().then(res=>{
                    if(res.code==1){
                        this.money=res.data.value;
                    }
                })
            },
            updateDk(){
                this.dkPop=true;
                this.update_money=this.money;
            },
            updateSer(){
                this.serPop=true;
                this.update_sale_money=this.sale_money;
            },
            submitDk(){
                if(!this.update_money){
                    this.$message.error('请输入金额');
                    return;
                }
                setdkmoney({money:this.update_money}).then(res=>{
                    if(res.code==1){
                        this.$message.success('设置成功');
                        this.dkPop=false;
                        this.getDkMoney();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            submitSer(){
                if(!this.update_sale_money){
                    this.$message.error('请输入金额');
                    return;
                }
                setsermoney({money:this.update_sale_money}).then(res=>{
                    if(res.code==1){
                        this.$message.success('设置成功');
                        this.serPop=false;
                        this.getSaleMoney();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
